import { render, staticRenderFns } from "./GoalMetricSelector.vue?vue&type=template&id=6a017990&scoped=true"
import script from "./GoalMetricSelector.vue?vue&type=script&lang=js"
export * from "./GoalMetricSelector.vue?vue&type=script&lang=js"
import style0 from "./GoalMetricSelector.vue?vue&type=style&index=0&id=6a017990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a017990",
  null
  
)

export default component.exports